import axios from 'axios';

export const getSSRsForDeviceService = async (deviceId) => {
  const response = await axios.get(`/ssrs?deviceId=${deviceId}`);
  return response.data?.data;
};

export const getAllAdminHeatersService = async () => {
  const response = await axios.get('/heaters/search');
  return response.data?.data;
};

export const getAdminHeatersService = async (partNumber) => {
  const response = await axios.get(`/heaters/search?partNumber=${partNumber}`);
  return response.data?.data;
};

export const addAdminHeatersService = async (data) => {
  const response = await axios.post('/heaters', data);
  return response.data?.data;
};

export const addHeaterToSSRService = async (deviceId, data) => {
  const response = await axios.post(`/ssrs/${deviceId}/heaters`, data);
  return response.data?.data;
};

export const deleteHeaterFromSSRService = async (deviceId, data) => {
  const response = await axios.delete(`/ssrs/${deviceId}/heaters`, { data });
  return response.data?.data;
};

export const updateHeaterOfSSRService = async (deviceId, data) => {
  const response = await axios.patch(`/ssrs/${deviceId}`, data);
  return response.data?.data;
};
